import PropTypes from 'prop-types';
import { Button, Form, Flex, ConfigProvider } from 'antd';
import { useTranslation } from 'react-i18next';
import { useGenerateFormItem } from '../../../utils/generateFormItem';
import { useSecondStepFields } from '../fields/secondStepFields';

export const SecondStep = ({
  form,
  secondStep,
  setSecondStep,
  setCurrent,
  questionnaireType,
  user,
  readOnly
}) => {
  const { t } = useTranslation();
  const { secondStepFields } = useSecondStepFields({
    questionnaireType,
    userRole: user.role
  });
  const gerenateFormItem = useGenerateFormItem();

  const handleSetSecondStepData = (data) => {
    setCurrent((current) => current + 1);
    setSecondStep({ ...secondStep, ...data });
  };

  return questionnaireType || user.role ? (
    <Form onFinish={handleSetSecondStepData} form={form} layout="vertical">
      <ConfigProvider componentDisabled={readOnly}>
        {secondStepFields.map((field) =>
          gerenateFormItem('owners.users_shows.review_drawer', field)
        )}
      </ConfigProvider>
      <Flex gap="small" justify="flex-end">
        <Button
          type="link"
          onClick={() => setCurrent((current) => current - 1)}
        >
          {t('buttons.previous')}
        </Button>
        <Button type="primary" htmlType="submit">
          {t('buttons.next')}
        </Button>
      </Flex>
    </Form>
  ) : null;
};

SecondStep.propTypes = {
  form: PropTypes.shape({}).isRequired,
  secondStep: PropTypes.shape({}),
  setSecondStep: PropTypes.func,
  setCurrent: PropTypes.func,
  questionnaireType: PropTypes.string,
  user: PropTypes.shape({
    role: PropTypes.string
  }),
  readOnly: PropTypes.bool
};

SecondStep.defaultProps = {
  secondStep: {},
  setSecondStep: () => {},
  setCurrent: () => {},
  questionnaireType: '',
  user: {},
  readOnly: false
};
